import { withInstall } from '../../../utils/with-install'
import PulseLinkLayer from './PulseLinkLayer.vue'

export const ElAmapLocaPulseLink = withInstall(PulseLinkLayer)
export default ElAmapLocaPulseLink
